<div
  class="date-picker"

  [class.active]="active"
  (keyup.enter)="onApply($event)"
  (keyup.escape)="closeCalendar()"
  [ngStyle]="overrideStyle"
>
  <div
    class="close-calendar"
    (click)="closeCalendar(); $event.stopPropagation()"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="11px"
      height="11px"
    >
      <path
        fill-rule="evenodd"
        fill="rgb(135, 155, 175)"
        d="M10.943,9.919 L9.888,10.974 L5.939,7.024 L1.990,10.974 L0.934,9.919 L4.884,5.969 L0.934,2.020 L1.990,0.965 L5.939,4.914 L9.888,0.965 L10.943,2.020 L6.994,5.969 L10.943,9.919 Z"
      />
    </svg>
  </div>
  <div class="time-pick" [hidden]="noTimePicker">
    <div
      class="hour"
      (click)="onHourInputFocus()"
      [class.active]="hourInputFocused"
    >
      <div class="pencil-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18.5"
          height="18.4"
          viewBox="0 0 18.5 18.4"
        >
          <path
            d="M11,3.9l3.6,3.6L6.2,15.8,2.6,12.2,11,3.9m0-1.1h-.2L1.6,12.1a.3.3,0,0,0,0,.4l4.4,4.4h.4l9.1-9.1a.3.3,0,0,0,0-.4L11.2,2.9Zm2.3,3-.6-.6L4.2,13.7l.6.6Zm.4-4.7,3.6,3.6L15.2,6.9,11.6,3.3l2.1-2.1m0-1.2L10.4,3.3l4.8,4.8,3.3-3.3L13.7,0ZM2.1,12.8h0l3.6,3.5L.9,17.5H.8l1.3-4.7h0m0-.8a.9.9,0,0,0-.8.6L0,17.3a.9.9,0,0,0,.9,1.1h.2L6,17.1a.8.8,0,0,0,.4-1.4L2.8,12.2a.9.9,0,0,0-.6-.3Z"
          />
        </svg>
      </div>
      <span class="description">HOUR</span>
      <input
        #hourInputElem
        #hourInput="ngModel"
        name="hour"
        [(ngModel)]="hours"
        (focus)="hourInputFocused = true"
        (blur)="onHourInputBlur(hourInput)"
        class="input-hour"
        type="text"
        pattern="([01]?[0-9]|2[0-3])"
        maxlength="2"
        placeholder="--"
        required
      />
    </div>

    <div
      class="minute"
      (click)="onMinutesInputFocus()"
      [class.active]="minutesInputFocused"
    >
      <div class="pencil-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18.5"
          height="18.4"
          viewBox="0 0 18.5 18.4"
        >
          <path
            d="M11,3.9l3.6,3.6L6.2,15.8,2.6,12.2,11,3.9m0-1.1h-.2L1.6,12.1a.3.3,0,0,0,0,.4l4.4,4.4h.4l9.1-9.1a.3.3,0,0,0,0-.4L11.2,2.9Zm2.3,3-.6-.6L4.2,13.7l.6.6Zm.4-4.7,3.6,3.6L15.2,6.9,11.6,3.3l2.1-2.1m0-1.2L10.4,3.3l4.8,4.8,3.3-3.3L13.7,0ZM2.1,12.8h0l3.6,3.5L.9,17.5H.8l1.3-4.7h0m0-.8a.9.9,0,0,0-.8.6L0,17.3a.9.9,0,0,0,.9,1.1h.2L6,17.1a.8.8,0,0,0,.4-1.4L2.8,12.2a.9.9,0,0,0-.6-.3Z"
          />
        </svg>
      </div>
      <span class="description">MINUTES</span>
      <input
        #minutesInputElem
        #minutesInput="ngModel"
        name="minutes"
        [(ngModel)]="minutes"
        (focus)="minutesInputFocused = true"
        (blur)="onMinutesInputBlur(minutesInput)"
        class="input-minute"
        type="text"
        pattern="[0-5]?[0-9]"
        maxlength="2"
        placeholder="--"
        required
      />
    </div>
  </div>

  <datepicker
    [(date)]="date"
    (onSelect)="onApply($event)"
    (onEscape)="closeCalendar()"
    [class.active]="active"
  ></datepicker>

  <div class="btn-apply" (click)="onApply($event); $event.stopPropagation()">
    <span>Apply</span>
  </div>
</div>
